import React, { useEffect, useState } from "react";
import { CreditState } from "../../stores/credit/credit-state.interface";
import { useCreditDispatch } from "../../stores/credit/credit.store";
import { updateCreditAvanseThunk } from "../../stores/credit/thunks/update-credit-avanse.thunk";
import { setAvanse } from "../../stores/credit/credit.reducer";
import { useCreditSelector } from "../../stores/product/product.store";

interface PrepaidProps {}

export const Prepaid: React.FC<PrepaidProps> = () => {
    const selectMonth = useCreditSelector((state: CreditState) => state.selectMonth);
    const avanse = useCreditSelector((state: CreditState) => state.avanse);
    const text = useCreditSelector((state: CreditState) => state.text);
    const [tempPrepaid, setTempPrepaid] = useState(avanse);
    const [prepaidString, setPrepaidString] = useState(String(avanse));
    const [min, setMin] = useState(selectMonth?.minAvans || 0);
    const [max, setMax] = useState(selectMonth?.maxAvans || 0);

    const dispatch = useCreditDispatch();

    useEffect(() => {
          if(selectMonth) {
              const min = selectMonth.minAvans;
              const max = selectMonth.maxAvans; 
              setMin(min);
              setMax(max);
              
              if(tempPrepaid < min) { changeAvanse(min, tempPrepaid) }
              else if(tempPrepaid > max) { changeAvanse(max, tempPrepaid) }
              else { changeAvanse(tempPrepaid, tempPrepaid) }
          }
    }, [selectMonth]);

    const minus = () => {
        const newTempPrepaid = Number(prepaidString) - 100;
        if (newTempPrepaid >= min) {
            changeTempPrepaid(newTempPrepaid);
        }
    };

    const plus = () => {
        const newTempPrepaid = Number(prepaidString) + 100;
        if (newTempPrepaid <= max) {
            changeTempPrepaid(newTempPrepaid);
        }
    };

    const changeTempPrepaid = (value: string | number) => {
        let newValue = Number(value);

        if(newValue < min) newValue = min;
        else if(newValue > max) newValue = max;

        setTempPrepaid(newValue);
        changeAvanse(newValue, Number(value));
    }

    const changeAvanse = (updateValue: number, temp = 0) => {
        if(updateValue !== avanse) {
            dispatch(setAvanse(updateValue));
            dispatch(updateCreditAvanseThunk({ avanse: updateValue, temp: temp }));
        }
        setPrepaidString(String(updateValue));
    }

    return (
        <div className="flex justify-center gap-x-16 items-center bg-light-gray p-2 rounded-xl">
            <div>
                <label htmlFor="advance" className="block text-sm font-semibold text-gray">
                    {text.avanse}
                </label>
            </div>
            <div className="flex justify-center items-center">
                <button className="text-yellow w-[32px] h-[32px] bg-white font-semibold rounded" onClick={minus}>
                    -
                </button>
                <input
                    type="number"
                    name="advance"
                    className="bg-light-gray text-center font-semibold w-auto border-none"
                    min={min}
                    max={max}
                    value={ prepaidString }
                    onChange={(e) => setPrepaidString(e.target.value)}
                    onBlur={(e) => changeTempPrepaid(e.target.value)}
                />
                <button className="text-yellow w-[32px] h-[32px] bg-white font-semibold rounded" onClick={plus}>
                    +
                </button>
            </div>
        </div>
    );
};